import * as actions from './features.actions';
import { Manager } from '../global/interfaces';

export interface State {
  loading: boolean;
  consultants: any;
}

export const initialState: State = {
  loading: false,
  consultants: []
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_CLIENT_CONSULTANTS:
      return {
        ...state,
        loading: true
      };
    case actions.ActionTypes.LOAD_CLIENT_CONSULTANTS_SUCCESS:
      return {
        ...state,
        consultants: action.payload
      };
    case actions.ActionTypes.LOAD_CLIENT_CONSULTANTS_FAILED:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}
